import(/* webpackMode: "eager" */ "/app/src/app/votigram/page.tsx")